import React, { useState } from 'react';
import '../styles/project.css';
import { Projects } from './Data';

export default function Project() {
    // State to hold the currently selected category
    const [selectedCategory, setSelectedCategory] = useState('all');

    // Function to filter projects based on selected category
    const filteredProjects = selectedCategory === 'all'
        ? Projects
        : Projects.filter(p => p.type === selectedCategory);

    const renderProjectItems = (projects) => {
        return projects.map((p, id) => (
            <div className='projectItem' key={id}>
                <a href={p.demo} target='blank'>
                    <img src={p.image} alt="" className='projectImage' />
                    <h3 className="projectItemTitle">{p.title}</h3>
                    <p className="projectDecs">{p.desc}</p>

                    <ul className="projectSkills">
                        {p.skills.map((s, id) =>
                            <li key={id} className='projectSkillsItem'>{s}</li>
                        )}
                    </ul>
                    <div className="projectLinks">
                        <a href={p.demo} target="_blank" rel="noopener noreferrer" className='projectLinkItem'>Demo</a>
                        <a href={p.source} target="_blank" rel="noopener noreferrer" className='projectLinkItem'>Source</a>
                    </div>
                </a>
            </div>
        ));
    };

    return (
        <section id='project' className="section projectContainer">
            <div className="title">projects
                <div className="titleCircle"></div>
                <div className="titleCircle"></div>
                <div className="titleCircle"></div>
            </div>

            {/* Category filter buttons */}
            <div className="categoryButtons">
                <button onClick={() => setSelectedCategory('all')} className={selectedCategory === 'all' ? 'active' : ''}>All</button>
                <button onClick={() => setSelectedCategory('landing')} className={selectedCategory === 'landing' ? 'active' : ''}>Landing Pages</button>
                <button onClick={() => setSelectedCategory('dashboard')} className={selectedCategory === 'dashboard' ? 'active' : ''}>Dashboards</button>
                <button onClick={() => setSelectedCategory('webapp')} className={selectedCategory === 'webapp' ? 'active' : ''}>Web Apps</button>
            </div>

            {/* Render filtered projects */}
            <div className="projects">
                {renderProjectItems(filteredProjects)}
            </div>
        </section>
    );
}
